
import {CvDataStateType, UPDATE_BRANDING_DATA,UPDATE_LEFT_SIDE_DATA,GENERATE_FROM_SAMPLE,RESET_DATA, UPDATE_RIGHT_SIDE_DATA, AppAction} from '../types'

import cleanData from '../cleanData'


//get data from local storage
let dataFromLocal=localStorage.getItem('cv-data')

let cvDataState=cleanData
if(dataFromLocal){
    cvDataState=JSON.parse(dataFromLocal) as CvDataStateType
}

export const initialState:CvDataStateType = cvDataState

const reducer = (state:CvDataStateType = initialState, action:AppAction):CvDataStateType => {
    switch (action.type) {      
    case UPDATE_RIGHT_SIDE_DATA:
        //update data to local storage 
        let _sr={...state}
        _sr.rightSide=action.rightSide
        localStorage.setItem('cv-data', JSON.stringify(_sr))        
        return {
         ...state,
         rightSide:action.rightSide
        }   
    case UPDATE_LEFT_SIDE_DATA:
         //update data to local storage 
         let _sl={...state}
         _sl.leftSide=action.leftSide
         localStorage.setItem('cv-data', JSON.stringify(_sl))        
        return {
         ...state,
         leftSide:action.leftSide
        }   
    case UPDATE_BRANDING_DATA:
        //update data to local storage 
        let _sb={...state}
        _sb.branding=action.branding
        localStorage.setItem('cv-data', JSON.stringify(_sb))  
        //update root color as per branding
        document.documentElement.style.setProperty('--cv-bg-left',action.branding.leftBg)         
        document.documentElement.style.setProperty('--cv-bg-right',action.branding.rightBg)         
        document.documentElement.style.setProperty('--cv-font-dark',action.branding.fontDark)         
        document.documentElement.style.setProperty('--cv-font-light',action.branding.fontLight)         
        document.documentElement.style.setProperty('--cv-line-separator',action.branding.lineSeperator)         
        return {
         ...state,
         branding:action.branding
        }   
    case GENERATE_FROM_SAMPLE:       
         //update data to local storage         
         localStorage.setItem('cv-data', JSON.stringify(action.data))          
        return {       
            rightSide:action.data.rightSide,
            leftSide:action.data.leftSide,
            branding:action.data.branding,
        }   
    case RESET_DATA: 
    //update data to local storage         
    localStorage.setItem('cv-data', JSON.stringify(cleanData))        
        return {           
                rightSide:cleanData.rightSide,
                leftSide:cleanData.leftSide,
                branding:cleanData.branding,
            }   
    default:
      return state

  }

}

export default reducer;